import { LocationUtilities, SiteUtilities } from '../utils';
import Cookie from 'js-cookie';
import GA4Utilities from '../utils/ga4-utilities';
import FsalesFormHandlers from './fsales-form-handlers';

const fwCrmSignupForm = function (form, response) {
  const $form = $(form);
  const firstName = $form.find('.first-name-form').val() || null;
  const lastName = $form.find('.last-name-form').val() || null;
  const email = $form.find('input[name^="email"]').val() || null;
  const emailHash = SiteUtilities.getShaHash(email);
  const domain = $form.find('.domain-form').val() || null;
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const planId = $form.data('plan_id') || null;
  const subProduct = $form.data('sub_product') || null;
  const product = $form.data('product');

  const redirect = SiteUtilities.trimAndremoveTrailingSlash($form.data('redirect'));
  const redirectAds = SiteUtilities.trimAndremoveTrailingSlash($form.data('redirect-ads'));
  const productDesign = $form.hasClass('product-signupform');
  const userAgent = SiteUtilities.getUserAgentForMobile();

  fwCrmSignupFormSuccess($form, true);
  const signupResponse = response['product_signup_response'];
  const redirectUrl = signupResponse['redirect_url'].replace(/\/$/, '');
  const accountId = (signupResponse.account && signupResponse.account.id) ? signupResponse.account.id : null;

  const geoLocation = LocationUtilities.getGeoLocation();
  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: $form.find('.phone-form').val() || '',
      company: $form.find('.company-form').val(),
      // Please dont forget the !
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_fsalesfirstreferrer: Cookie.get('fw_flu') || '',
        cf_fsalessignupreferrer: window.location.href || '',
        cf_fsalescustomerstatus: 'Trial',
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      },
      domainUrl: redirectUrl,
      product: 'FW CRM',
      accountId: accountId,
      composite_stitching_key: response.composite_stitching_key || null
    }
  };
  GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
  SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'FW CRM');
  if (subProduct) {
    freshmarketerData.freshmarketerObject.custom_field.cf_subproduct = subProduct;
  }

  if (SiteUtilities.GDPRFunctionalCookieDisabled()) {
    freshmarketerData.freshmarketerObject['country'] = geoLocation ? geoLocation.countryName : '';
  } else {
    freshmarketerData.freshmarketerObject['city'] = geoLocation ? geoLocation.cityName : '';
    freshmarketerData.freshmarketerObject['state'] = geoLocation ? geoLocation.regionName : '';
    freshmarketerData.freshmarketerObject['country'] = geoLocation ? geoLocation.countryName : '';
    freshmarketerData.freshmarketerObject['zipcode'] = geoLocation ? geoLocation.zipCode : '';
  }
  let thankYouRedirect;
  if (!productDesign) {
    // Code to add a param to the thank-you page for referral program sign-ups
    const utmSource = SiteUtilities.getParameterByName('utm_source');
    let referralParam = '';
    if (utmSource && utmSource === 'invitereferrals') {
      referralParam = '&referral_sign_up=' + encodeURIComponent('true') + '&email=' + encodeURIComponent(email) + '&username=' + encodeURIComponent(firstName + ' ' + lastName);
    }

    const planName = SiteUtilities.getParameterByName('plan');
    // Storing the redirect url locally to avoid XSS from url.
    if (product !== 'fsales' && product !== 'fwcrm') {
      (planName && planName !== '') ? localStorage.setItem('redirect_url', redirectUrl + '?plan=' + planName) : localStorage.setItem('redirect_url', redirectUrl);
    }
    // Code to add a param to the thank-you page for plan-signups (PL-ADS)
    if (planName && planName !== '') {
      const planParam = '&plan=' + encodeURIComponent(planName);
      thankYouRedirect = `${redirectAds}/?${planParam}&redirect=${encodeURIComponent(redirectUrl)}${planParam}${referralParam}&ehash=${emailHash}`;
    } else {
      thankYouRedirect = `${redirect}/?redirect=${encodeURIComponent(redirectUrl)}${referralParam}&ehash=${emailHash}`;
    }
    if (isExternalIframeSignup) {
      thankYouRedirect = thankYouRedirect + '&post_to_partner=true';
      if (currentReferrer) {
        thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
      }
    }
    thankYouRedirect = (planId) ? `${thankYouRedirect}${thankYouRedirect.includes('?') ? '&' : '/?'}plan_id=${planId}` : thankYouRedirect;
  }
  if (!productDesign && (product === 'fsales' || product === 'fwcrm')) {
    const loadGtmScriptsOnSignupCompletionAsync = (thankYouRedirect) => {
      SiteUtilities.historyPushState(thankYouRedirect, false);
      const inlineConversionScript = document.createElement('script');
      inlineConversionScript.type = 'text/javascript';
      inlineConversionScript.innerHTML = `
        var google_conversion_id = 880828900;
        var google_conversion_label = "lnT6CLmn-WYQ5MOBpAM";
        var google_remarketing_only = false;
      `;
      document.head.appendChild(inlineConversionScript);

      window.dataLayer = window.dataLayer || [];
      const gtag = (...args) => window.dataLayer.push(args);

      const trackSignupConversion = () => {
        gtag('js', new Date());
        gtag('config', 'UA-78569416-1');
      };

      // Create an array of script URLs to load in parallel
      const scriptUrls = [
        'https://www.googletagmanager.com/gtag/js?id=UA-78569416-1',
        'https://www.googleadservices.com/pagead/conversion.js'
      ];

      return Promise.all(scriptUrls.map(SiteUtilities.loadScriptWithPromise))
        .then(() => {
          trackSignupConversion();
        })
        .catch(error => {
          SiteUtilities.log(
            'Error in loadGtmScriptsOnSignupCompletionAsync',
            'error',
            'fwcrm-form-handlers.js',
            1,
            error
          );
        });
    };
    const leadCapture = () => {
      const growSumoPayload = SiteUtilities.buildGrowSumoPayload('pk_I0c7qjS8TciKE3HTMqa5yalHg8J6f8ES', '');
      const collectorPayload = SiteUtilities.freshmarketerPost(freshmarketerData, false, $form, false);
      const admitadPayload = SiteUtilities.buildAdmitadPayload(growSumoPayload.customer_key);
      localStorage.setItem('fmarketerStartTime', new Date().toISOString());
      jQuery.when(
        SiteUtilities.postToKinesis({ growSumoPost: growSumoPayload, fmCollectorPost: collectorPayload, admitadPost: admitadPayload }),
        loadGtmScriptsOnSignupCompletionAsync(thankYouRedirect)
      ).catch(function (e) {
        SiteUtilities.log(
          'Error in Freshmarketer or GrowSumo Post API Call',
          'error',
          'fwcrm-form-handlers.js',
          1,
          e
        );
      }).always(function () {
        localStorage.setItem('fmarketerEndTime', new Date().toISOString());
        localStorage.removeItem('gsdata');
        SiteUtilities.triggersignupPerformanceLogApi(true);
        SiteUtilities.signupToProductRedirect(redirectUrl, isExternalIframeSignup);
      });
    };
    setTimeout(leadCapture, 0);
  } else {
    // Trigger trackingCompleted only after both the freshmarketer functions are completed
    jQuery.when(
      SiteUtilities.freshmarketerPost(freshmarketerData, false, $form)
    ).then(function () {
      localStorage.setItem('fmarketerEndTime', new Date().toISOString());
      jQuery('body').trigger('trackingCompleted');
    });

    // Code to add a param to the thank-you page for plan-signups (PL-ADS)
    jQuery('body').on('trackingCompleted', () => {
      if (productDesign) {
        if (!userAgent.length) {
          localStorage.setItem('thankyouRedirectStartTime', new Date().toISOString());
          window.location.href = redirectUrl;
        }
      }
      if (!productDesign) {
        // Send data to google analytics
        try {
          const trackers = ga.getAll();
          for (let t = 0; t < trackers.length; t++) {
            if (trackers[t].get('trackingId') === 'UA-78569416-1') {
              const trackerName = trackers[t].get('name');
              ga(trackerName + '.set', {
                page: `${SiteUtilities.removeTrailingSlashEnd(window.location.href)}/thank-you/?redirect=${redirectUrl}&ehash=${emailHash}`,
                title: 'Signup Complete',
                dimension1: domain + '.freshsales.io',
                dimension8: SiteUtilities.sanitizeGACookie(SiteUtilities.getGAClientID())
              });
              ga(trackerName + '.send', 'pageview', {
                page: `${SiteUtilities.removeTrailingSlashEnd(window.location.href)}/thank-you/?redirect=${redirectUrl}&ehash=${emailHash}`,
                title: 'Signup Complete'
              });
              break;
            }
          }
        } catch (e) {
          console.log(e);
        }
        localStorage.setItem('thankyouRedirectStartTime', new Date().toISOString());
        window.location.href = thankYouRedirect;
      }
    });
  }
};

const fwCrmSignupFormSuccess = ($form, success) => {
  const productDesign = $form.hasClass('product-signupform');
  const $thankYouCard = $form.closest('.product-form-wrapper').find('.thank-you-card');
  const $submitButton = $form.find('.button');
  if (productDesign) {
    $('html, body').animate({ scrollTop: 0 }, 0);
    $form.parent('.product-form-container').addClass('active');
    $thankYouCard.addClass('active');
    $submitButton.removeClass('button--product-disabled').removeAttr('disabled');
  }
  if (success) {
    if (productDesign) {
      $thankYouCard.find('.product-form-success').removeClass('hide');
      $thankYouCard.find('.product-form-failure').addClass('hide');
    }
  } else {
    if (productDesign) {
      $thankYouCard.find('.product-form-success').addClass('hide');
      $thankYouCard.find('.product-form-failure').removeClass('hide');
    } else {
      $submitButton.removeClass('button--loading').val('Retry').removeAttr('disabled');
    }
  }
};

// Freshsales Suite Account
const fwcrmAccountLogin = (domain, subdomainProduct) => {
  const error = {};

  const getAccountUrl = (url) => {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url,
        type: 'GET',
        success: function (response, textStatus, jqXHR) {
          const { status } = jqXHR;
          const { alias } = response || {};
          resolve(status === 200 ? (alias || null) : null);
        },
        error: function (xhr, status, err) {
          reject(xhr);
        }
      });
    });
  };

  const domainAvailabilityCheck = (url) => {
    return new Promise(function (resolve, reject) {
      $.ajax({
        url,
        type: 'GET',
        success: function (response, textStatus, jqXHR) {
          const { status } = jqXHR;
          const { region_code: regionCode } = response || {};
          resolve(status === 200 ? (regionCode || null) : null);
        },
        error: function (xhr, status, err) {
          reject(xhr);
        }
      });
    });
  };

  const getData = async (resolve, reject, loginUrl, availabilityApiUrl, accountApiUrl) => {
    try {
      const regionCode = await domainAvailabilityCheck(availabilityApiUrl);
      if (!regionCode) throw (Object.assign(error, { status: 404 }));
      const alias = await getAccountUrl(accountApiUrl.replace('%regionCode%', regionCode));
      if (!alias) throw (Object.assign(error, { status: 404 }));
      resolve(loginUrl + (alias.charAt(0) === '/' ? '' : '/') + alias);
    } catch (err) {
      reject(err);
    }
  };

  return new Promise((resolve, reject) => {
    if (!domain || !subdomainProduct) reject(Object.assign(error, { status: 400 }));
    const loginUrl = `https://${domain}${subdomainProduct}`;
    const availabilityApiUrl = `https://accounts-us.freshworks.com/api/v2/organisations/domain/${domain}${subdomainProduct}/available`;
    const accountApiUrl = `https://alfred.freshworks.com/v1/fwcrm/login-handler?domain=${domain}${subdomainProduct}&region=%regionCode%`;
    getData(resolve, reject, loginUrl, availabilityApiUrl, accountApiUrl);
  });
};

const fwcrmLoginForm = function (classname, form) {
  const $form = $(form);
  const domain = $form.find('input.domain-form').val().trim();
  const subdomainProduct = $form.find('.subdomain-product').val().trim();
  if (!domain || !subdomainProduct) return;

  $form.find('input.domain-form').parents('.form-field').removeClass('error');
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');

  const loginStatus = {
    resolved: null,
    rejected: null
  };

  const loginFailureCallback = (xhr, $form) => {
    if (!$form) return;
    const { status } = xhr || {};
    $form.find('.button').removeClass('button--loading').removeAttr('disabled');
    $form.find('.domain-form').parents('.form-field').addClass('error');
    if (status === 404) {
      $form.find('.error-wrapper').append("<em class='error'>Domain does not exist</em>");
    } else {
      $form.find('.error-wrapper').append("<em class='error'>Error contacting the server</em>");
    }
  };

  (async function () {
    await Promise.all([
      SiteUtilities.returnResolvedPromise(fwcrmAccountLogin(domain, subdomainProduct), loginStatus),
      SiteUtilities.returnResolvedPromise(FsalesFormHandlers.fsalesClassicAccountLogin(domain), loginStatus)
    ]);
    const { resolved, rejected } = loginStatus;
    if (resolved) window.location.href = resolved;
    else throw (rejected);
  })().catch(function (err) {
    loginFailureCallback(err, $form);
  });
  GA4Utilities.loginFormSubmit(domain);
};

const fwcrmForgotDomainForm = function (classname, form) {
  // For now this will be empty
};

export default {
  fwCrmSignupForm,
  fwCrmSignupFormSuccess,
  fwcrmAccountLogin,
  fwcrmLoginForm,
  fwcrmForgotDomainForm
};
